// /* eslint-disable camelcase */
import { crypto_scalarmult, crypto_scalarmult_base } from './crypto_scalarmult';
import { randombytes } from './randombytes';
import { crypto_generichash_batch } from './crypto_generichash';
import { crypto_secretbox_open_easy, crypto_secretbox_easy } from './crypto_secretbox';
import xsalsa20 from '../xsalsa20';

export const crypto_box_PUBLICKEYBYTES = 32;
export const crypto_box_SECRETKEYBYTES = 32;
export const crypto_box_NONCEBYTES = 24;
export const crypto_box_SEALBYTES = 48;
export const crypto_box_BEFORENMBYTES = 32;

export function crypto_box_keypair(pk, sk) {
  check(pk, crypto_box_PUBLICKEYBYTES);
  check(sk, crypto_box_SECRETKEYBYTES);
  randombytes(sk, 32);
  return crypto_scalarmult_base(pk, sk);
}

export function crypto_box_seal(c, m, pk) {
  check(c, crypto_box_SEALBYTES + m.length);
  check(pk, crypto_box_PUBLICKEYBYTES);

  var epk = c.subarray(0, crypto_box_PUBLICKEYBYTES);
  var esk = new Uint8Array(crypto_box_SECRETKEYBYTES);
  crypto_box_keypair(epk, esk);

  var n = new Uint8Array(crypto_box_NONCEBYTES);
  crypto_generichash_batch(n, [epk, pk]);

  var s = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  crypto_scalarmult(s, esk, pk);

  var k = new Uint8Array(crypto_box_BEFORENMBYTES);
  var zero = new Uint8Array(16);
  xsalsa20.core_hsalsa20(k, zero, s, xsalsa20.SIGMA);

  crypto_secretbox_easy(c.subarray(epk.length), m, n, k);

  cleanup(esk);
}

export function crypto_box_seal_open(m, c, pk, sk) {
  check(c, crypto_box_SEALBYTES);
  check(m, c.length - crypto_box_SEALBYTES);
  check(pk, crypto_box_PUBLICKEYBYTES);
  check(sk, crypto_box_SECRETKEYBYTES);

  var epk = c.subarray(0, crypto_box_PUBLICKEYBYTES);

  var n = new Uint8Array(crypto_box_NONCEBYTES);
  crypto_generichash_batch(n, [epk, pk]);

  var s = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  crypto_scalarmult(s, sk, epk);

  var k = new Uint8Array(crypto_box_BEFORENMBYTES);
  var zero = new Uint8Array(16);
  xsalsa20.core_hsalsa20(k, zero, s, xsalsa20.SIGMA);

  return crypto_secretbox_open_easy(m, c.subarray(epk.length), n, k);
}

export function check(buf, len) {
  if (!buf || (len && buf.length < len))
    throw new Error('Argument must be a buffer' + (len ? ' of length ' + len : ''));
}

export function cleanup(arr) {
  for (let i = 0; i < arr.length; i++) arr[i] = 0;
}
